<template>
  <div class="custom_data_check" v-loading="pageLoading">
    <div class="inner-wrap">
      <div class="info_list">
        <div class="info_title">基本信息</div>
        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">上传人:</div>
            <div class="info_item_text">{{member_truename}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">更新时间:</div>
            <div class="info_item_text">{{update}}</div>
          </div>
        </div>
       </div>

      <div class="info_list">
        <div class="info_title">终端信息</div>
        <div class="info_item">
        <div class="info_item_left">
            <div class="info_item_label">客户名称:</div>
            <div class="info_item_text">{{name}}</div>
        </div>
        <div class="info_item_right">
            <div class="info_item_label">终端类型:</div>
            <div class="info_item_text">{{org_type_3_text}}</div>
        </div>
        </div>
        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">终端类别:</div>
            <div class="info_item_text">{{org_type_4_text}}</div>
          </div>
          <div class="info_item_right" v-if="ylOptions.includes(org_type_3)">
            <div class="info_item_label">经营性质:</div>
            <div class="info_item_text">{{reg_type_1_text}}</div>
          </div>
        </div>
        <div class="info_item"  v-if="ylOptions.includes(org_type_3)">
          <div class="info_item_left">
              <div class="info_item_label">药聚汇_等级:</div>
              <div class="info_item_text">{{dj}}</div>
          </div>
          <div class="info_item_right">
              <div class="info_item_label">是否军区:</div>
              <div class="info_item_text">{{is_junqu}}</div>
          </div>
        </div>

        <div class="info_item"  v-if="ylOptions.includes(org_type_3)">
          <div class="info_item_left">
              <div class="info_item_label">定级:</div>
              <div class="info_item_text">{{le_type_2_text}}</div>
          </div>
          <div class="info_item_right">
              <div class="info_item_label">定等:</div>
              <div class="info_item_text">{{le_type_3_text}}</div>
          </div>
        </div>

        <div class="info_item"  v-if="ylOptions.includes(org_type_3)">
          <div class="info_item_left">
              <div class="info_item_label">所有制形式:</div>
              <div class="info_item_text">{{reg_type_2_text}}</div>
          </div>
        </div>
      </div>

      <div class="info_list">
        <div class="info_title">地址信息</div>
        <div class="info_item">
        <div class="info_item_left">
            <div class="info_item_label">省:</div>
            <div class="info_item_text">{{p_name}}</div>
        </div>
        <div class="info_item_right">
            <div class="info_item_label">市:</div>
            <div class="info_item_text">{{city_name}}</div>
        </div>
        </div>
        <div class="info_item">
        <div class="info_item_left">
            <div class="info_item_label">区县:</div>
            <div class="info_item_text">{{ad_name}}</div>
        </div>
        <div class="info_item_right">
            <div class="info_item_label">详细地址:</div>
            <div class="info_item_text">{{address}}</div>
        </div>
        </div>
      </div>

      <div class="info_list">
        <div class="info_title">凭证信息</div>
        <div class="info_item" v-if="this.$route.params.type * 1 === 10 ">
          <div class="info_item_left info_item_left_img">
            <div class="info_item_label">截图凭证:</div>
            <div class="info_item_text info_item_text-ping">
              <span class="info_item_text-ping-label">{{pingzhengName}}</span>
              <span class="chakan" @click="chakanFn(true)">查看</span>
            </div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">原始链接:</div>
            <div class="info_item_text"><a href="javascript:void(0)" @click="changeUrl">{{frontend_original_url}}</a></div>
          </div>
        </div>

         <div class="info_item" v-if="this.$route.params.type * 1 === 100 ">
          <div class="info_item_left">
            <div class="info_item_label">原始链接:</div>
            <div class="info_item_text"><a href="javascript:void(0)" @click="changeUrl">{{frontend_original_url}}</a></div>
          </div>
        </div>
      </div>

      <div class="info_list info_list_last">
        <div class="info_title">数据库信息查询</div>
        <div class="search_area_wrap">
          <Input placeholder="请输入客户名称" v-model.trim="searchText" @keyup.enter.native="searchNew" />
          <i class="iconfont iconsousuo" @click="searchNew"></i>
        </div>
      </div>
      <div style="" v-loading="loading">
        <v-table
          ref="checkTable"
          :is-vertical-resize="false"
          is-horizontal-resize
          style="width:100%"
          :title-row-height="34"
          :row-height="34"
          :show-horizontal-border="true"
          :show-vertical-border="true"
          even-bg-color="#F8FAFB"
          odd-bg-color="#FFFFFF"
          title-bg-color="#EDF2F4"
          row-hover-color="#EDF5FC"
          :columns="col"
          :table-data="tableData"
          :error-content-height="90"
        ></v-table>
      </div>
    </div>
    <!-- 查看图片弹框 -->
    <div class="fix_chakan_img" v-if="chakanShow">
      <div class="chakan_img_wrap">
        <img :src="curPreSrc + pingzheng" alt="">
      </div>
      <i class="chakan_img_close iconquxiao iconfont" @click="chakanShow = false"></i>
    </div>
    <!-- 底部操作项 -->
    <page-bottom-line text="提交保存" @confirm="submit" pageType="newapply">
        <Button @click="bohuiDiag">驳回</Button>
        <Button @click="confirmPass" type="primary" :disabled="checkSending">通过</Button>
    </page-bottom-line>
    <!-- 拒绝弹框 -->
    <simple-diag
      class="submit-error-diag"
      width="400px"
      title="驳回原因"
      confirmText="提交"
      :isShow="show"
      @close="close"
      @confirm="confirm"
    >
      <div class="check_custom_diag_wrap">
        <span class="error-describe" :class="{ 'is-red': isRed }"><i>{{content.length || 0}}</i>/200</span>
        <Input
          type="textarea"
          placeholder="请输入内容"
          v-model.trim="content"
          :maxlength="200"
          show-word-limit
          resize="none"
          class="check_custom_data_img"
        />
      </div>
    </simple-diag>
  </div>
</template>
<script>
import '@/components/vue-easytable/themes-base/index.css'
import { VTable } from '@/components/vue-easytable'
import pageBottomLine from '@/components/pageCom/pageBottomLine.vue'
import simpleDiag from '@/components/dialogs/simpleDiag.vue'
import { getCustomCheckInfo, customCheckReject, customCheckPass, replaceData, customHuiCheckPass, customHuiCheckReject } from '@/api/goodStand.js'
export default {
  name: 'customDataCheck',
  components: { VTable, pageBottomLine, simpleDiag },
  data() {
    return {
      pageLoading: false, // 页面loading
      loading: false, // 表格loading
      searchText: '', // 搜索参数
      chakanShow: false,
      tableData: [],
      yaojuhuiOpts: [
        { value: '1', text: '三级甲等' }, { value: '2', text: '三级乙等' }, { value: '3', text: '三级丙等' },
        { value: '4', text: '二级甲等' }, { value: '5', text: '二级乙等' }, { value: '6', text: '二级丙等' }, { value: '7', text: '一级甲等' },
        { value: '8', text: '一级乙等' }, { value: '9', text: '一级丙等' }, { value: '10', text: '未定级未定等' }, { value: '11', text: '三级' },
        { value: '12', text: '三级未定等' }, { value: '13', text: '二级' }, { value: '14', text: '二级未定等' }, { value: '15', text: '一级' },
        { value: '16', text: '一级未定等' }, { value: '17', text: '未定级甲等' }, { value: '18', text: '未定级乙等' }, { value: '19', text: '未定级丙等' },
        { value: '20', text: '未定级' }, { value: '22', text: '未定等' }
      ],
      col: [
        { field: 'score', title: '评分推荐  ', isResize: true, width: 70, titleAlign: 'left', columnAlign: 'left' },
        { field: 'name', title: '客户名称-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'history_name', title: '曾用名-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'p_name', title: '省-标准化', isResize: true, width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'city_name', title: '市-标准化', isResize: true, width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'ad_name', title: '区/县-标准化', isResize: true, width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'address', title: '地址-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'dj', title: '药聚汇等级-标准化', isResize: true, width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'org_type_2_text', title: '终端分类-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'org_type_3_text', title: '终端类型-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'org_type_4_text', title: '终端类别-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'reg_type_1_text', title: '经营性质-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'le_type_2_text', title: '定级-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'le_type_3_text', title: '定等-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'reg_type_2_text', title: '所有制形式-标准化', isResize: true, width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'is_junqu', title: '是否军区-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'frontend_original_url', title: '网站链接-标准化', isResize: true, width: 120, titleAlign: 'left', columnAlign: 'left' }
      ],
      show: false, // 弹框是否显示
      content: '', // 拒绝原因
      member_truename: '', // 上传人
      update: '', // 更新时间
      name: '', // 客户名称
      org_type_3: '', // 判断是不是医院 11 代表医院
      org_type_3_text: '', // 终端类型
      org_type_4_text: '', // 终端类别
      reg_type_1_text: '', // 经营性质
      dj: '', // 药聚汇等级
      is_junqu: '', // 是否军区
      p_name: '',
      city_name: '',
      ad_name: '',
      address: '',
      pingzhengName: '', // 凭证名字
      pingzheng: '', // 截图凭证
      frontend_original_url: '', // 原始链接地址
      checkSending: false,
      le_type_2_text: '', // 定级文案
      le_type_3_text: '', // 定等文案
      reg_type_2_text: '', // 所有制文案
      ylOptions: ['11', '12', '13', '14'],
      isSendReject: false
    }
  },
  computed: {
    isRed() {
      return this.content && (this.content.length === 200)
    },
    curPreSrc() {
    //   return process.env.NODE_ENV === 'development' ? 'https://test.data.pharmconverge.com/' : 'https://data.pharmconverge.com/'
      return process.env.VUE_APP_ADD_PRE
    }
  },
  mounted() {
    this.$store.commit('SET_RETURN_TITLE', this.$route.params.type * 1 === 100 ? '恢复数据审核' : '新增数据审核')
    this.$store.commit('SET_RETURN_URL', '/qiyeStand/kehuData/3')
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.pageLoading = true
      getCustomCheckInfo({
        id: this.$route.params.id
      }).then(res => {
        this.pageLoading = false
        if (res.code === 0) {
          const data = res.result.old_info
          this.member_truename = res.result.member_truename
          this.update = res.result.shenqing_shijian
          this.name = data.name
          this.org_type_3 = data.org_type_3
          this.org_type_3_text = data.org_type_3_text
          this.org_type_4_text = data.org_type_4_text
          this.reg_type_1_text = data.reg_type_1_text
          this.dj = data.dj
          this.is_junqu = data.is_junqu
          this.p_name = data.p_name
          this.city_name = data.city_name
          this.ad_name = data.ad_name
          this.address = data.address
          // 定级 定等 所有制形式文案
          this.le_type_2_text = data.le_type_2_text || ''
          this.le_type_3_text = data.le_type_3_text || ''
          this.reg_type_2_text = data.reg_type_2_text || ''
          this.pingzhengName = res.result.frontend_screen_img_attach[0] ? res.result.frontend_screen_img_attach[0].origin_name : ''
          this.pingzheng = res.result.frontend_screen_img_attach[0] ? res.result.frontend_screen_img_attach[0].path : ''
          this.frontend_original_url = data.frontend_original_url
          if (data.name) {
            this.search(data.name)
          }
        }
      })
    },
    searchNew() {
      if (this.searchText === '') return
      this.search(this.searchText)
    },
    search(value) { // 搜索数据表数据方法
      this.loading = true
      replaceData({
        change_type: 1, search_content: value,
        p_name: '', city_name: '', ad_name: ''
      }).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.tableData = res.result.data_list.filter(obj => {
            return obj.score >= 85
          })
          this.initTableScroll()
        } else {
          this.tableData = []
          this.$Message.info(res.msg)
        }
      })
    },
    chakanFn(flag) { // 点击查询图片
      this.chakanShow = flag
    },
    submit() {
    },
    close() {
      this.show = false
      this.content = ''
    },
    confirm() { // 确定驳回
      if (this.content === '') {
        this.$Message.info('请输入驳回原因')
        return
      }
      if (this.isSendReject) return
      this.isSendReject = true
      if (this.$route.params.type * 1 === 100) { // 恢复审核
        customHuiCheckReject({
          id: this.$route.params.id,
          backend_reject_msg: this.content
        }).then(res => {
          this.isSendReject = false
          if (res.code === 0) {
            this.$Message.info('驳回成功')
            this.show = false
            this.content = ''
            this.$router.push('/qiyeStand/kehuData/3')
          } else {
            this.$Message.info(res.msg)
          }
        })
      } else if (this.$route.params.type * 1 === 10) { // 新增审核
        customCheckReject({
          id: this.$route.params.id,
          backend_reject_msg: this.content
        }).then(res => {
          this.isSendReject = false
          if (res.code === 0) {
            this.$Message.info('驳回成功')
            this.show = false
            this.content = ''
            this.$router.push('/qiyeStand/kehuData/3')
          } else {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    bohuiDiag() {
      this.show = true
    },
    confirmPass() { // 通过审核
      if (this.checkSending) return
      this.checkSending = true
      if (this.$route.params.type * 1 === 100) { // 恢复审核
        customHuiCheckPass({
          id: this.$route.params.id
        }).then(res => {
          this.checkSending = false
          if (res.code === 0) {
            this.$Message.info('通过审核')
            this.$router.push('/qiyeStand/kehuData/3')
          } else {
            this.$Message.info(res.msg)
          }
        })
      } else if (this.$route.params.type * 1 === 10) { // 新增审核
        customCheckPass({
          id: this.$route.params.id
        }).then(res => {
          this.checkSending = false
          if (res.code === 0) {
            this.$Message.info('通过审核')
            this.$router.push('/qiyeStand/kehuData/3')
          } else {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    initTableScroll() {
      document.querySelector('.v-table-body').scrollLeft && (document.querySelector('.v-table-body').scrollLeft = 0)
      document.querySelector('.v-table-header').scrollLeft && (document.querySelector('.v-table-header').scrollLeft = 0)
    },
    // 原始凭证-跳转
    changeUrl() {
      if (this.frontend_original_url.includes('http')) {
        window.open(this.frontend_original_url)
      } else {
        window.open('http://' + this.frontend_original_url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
/deep/ .el-loading-mask {
    z-index: 0;
}
.inner-wrap {
  max-width: 900px;
  margin: 20px auto 10px;
  background: $white;
  padding: 0 30px;
}
.info_list {
  padding: 30px 0 10px 0;
  border-bottom: 1px solid #F2F7FB;
  &_last {
    padding-bottom: 0px;
    position: relative;
  }
  .info_title {
    height: 14px; font-size: 14px; line-height: 14px; color: #5d6f80;
    font-weight: 600; margin-bottom: 24px;
  }
  .info_item {
    display: flex;
    margin-bottom: 20px;
  }
  .info_item_left {
    display: flex;
    width: 430px;
    position: relative;
  }
  .info_item_right {
    width: 410px;
    display: flex;
    position: relative;
  }
  .info_item_label {
    width: 110px;
    text-align: right;
    font-size: 12px;
    line-height: 18px;
    margin-right: 10px;
  }
  .info_item_text {
    flex: 1;
    font-size: 12px;
    line-height: 18px;
    // white-space: wrap;
    position: absolute;
    width: 100%;
    padding-left: 120px;
    white-space: normal;
    word-break:break-all;

    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    a { color: $blue; text-decoration: underline; }
  }
  .info_item_text-ping {
    max-width: 400px;
    padding-right: 50px;
    width: auto !important;
  }
  .info_item_text-ping-label {
    max-width: 228px;
  }
  .chakan {
    position: absolute; right: 0px; top: 0px; color: $blue;
    text-decoration: underline; cursor: pointer;
  }
}
.info_list_last {
  position: relative;
  .search_area_wrap {
    position: absolute;
    width: 220px;
    height: 32px;
    right: 0px;
    top: 22px;
    /deep/ .ivu-input-wrapper {
      height: 32px;
      line-height: 32px;
      .ivu-input {
        height: 32px;
        line-height: 32px;
        padding-right: 26px;
      }
    }
    .iconfont {
      position: absolute;
      right: 8px;
      top: 8px;
      cursor: pointer;
    }
  }
}
.ivu-btn {
  width: 68px;
  height: 28px;
}
.fix_chakan_img {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, .3);
  z-index: 1000;
  .chakan_img_wrap {
    width: 970px;
    height: 580px;
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -485px;
    padding: 20px;
    background: $white;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .chakan_img_close {
    color: #C1CFDB;
    font-size: 28px;
    position: absolute;
    width: 28px;
    height: 28px;
    right: 60px;
    top: 60px;
    cursor: pointer;
    z-index: 100;
  }
}
/deep/ .v-table-header:before  {
  display: none;
}
/deep/ .v-table-title-cell {
  font-weight: 600;
}
</style>
<style lang="scss">
@import '@/styles/color.scss';
.check_custom_diag_wrap {
  box-sizing: border-box;
  position: relative;
  margin: 0 20px;
  padding: 6px 0px 0 10px;
  border: 1px solid #BECAD6;
  height: 128px;
  /deep/ .error-describe {
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
    line-height: 12px;
    i {
      font-style: normal;
    }
  }
  /deep/ .is-red {
    i {
      color: $red;
    }
  }
}
.check_custom_data_img {
  border: none;
  /deep/ .ivu-input {
    width: 100%;
    height: 90px;
    padding: 0;
    font-size: 13px;
    border: none;
    color: #333333;
    resize:none;
  }
}
.info_item_left_img {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>
